import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: {
        "max-width": "600px",
        "overlay-opacity": "0.6",
        elevation: "8",
        persistent: "",
      },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.cancel.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        VCard,
        [
          _c(
            VToolbar,
            {
              attrs: {
                dark: "",
                color: "red darken-2 text-none",
                dense: "",
                flat: "",
              },
            },
            [
              _c(VToolbarTitle, { attrs: { dark: "" } }, [
                _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VCardText,
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !!_vm.message,
                  expression: "!!message",
                },
              ],
              staticClass: "pa-4",
            },
            [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            VCardActions,
            { staticClass: "pt-0" },
            [
              _c(VSpacer),
              _vm._v(" "),
              _c(
                VBtn,
                {
                  attrs: { color: "primary darken-1", text: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.agree.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" OK ")]
              ),
              _vm._v(" "),
              _c(
                VBtn,
                {
                  attrs: { color: "grey", text: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.cancel.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" Abbrechen ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }